/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-restricted-exports */
/* eslint-disable @typescript-eslint/no-magic-numbers */
import clevertap from 'clevertap-web-sdk';

import logger from '@/logger';

let clevertapInitialized = false;

export function initCleverTap() {
  const enableCleverTap = import.meta.env.VITE_ENABLE_CLEVERTAP === 'true' || false;

  if (!enableCleverTap) {
    logger.info('CleverTap is not enabled');
    return;
  }

  if (clevertapInitialized) {
    logger.warn('CleverTap is already initialized');
    return;
  }

  try {
    const accountId = import.meta.env.VITE_CLEVERTAP_ACCOUNT_ID as string;
    const region = (import.meta.env.VITE_CLEVERTAP_REGION as string) || 'in1';

    if (!accountId) {
      logger.error('CleverTap Account ID is missing');
      return;
    }

    clevertap.init(accountId, region);
    clevertap.spa = true;
    clevertap.setLogLevel(3);

    clevertapInitialized = true;
    logger.info('CleverTap initialized successfully');
  } catch (error) {
    logger.error('Error initializing CleverTap:', error);
  }
}

export function getCleverTapInstance() {
  if (!clevertapInitialized) {
    logger.warn('CleverTap is not initialized. Call initCleverTap() first.');
    //eslint-disable-next-line unicorn/no-null
    return null;
  }
  return clevertap;
}

export default clevertap;
